<template>
  <section>
    <reload v-if="reload_hab"></reload>
    <div class="container wfs--main">
      <div class="row">
        <div class="col-md-12 bread">
          <ol class="bread-crumb breadcrumb-fill0">
              <li><router-link to="/home">home</router-link></li>
              <li><a href="javascript:void(0);" class="bread-text ">Login</a></li>
          </ol>
        </div>
        <div class="col-md-12" v-if="resposta" style="padding:0px!important">
            <div class="card" style="margin-top:20px;background-color: rgb(187 93 78) !important;color: #fff !important;" >
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12" >
                      {{resposta}}
                  </div>
                </div>
                
              </div>  
            </div> 
        </div>
        
        <!--Nova Senha-->  
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-6">
                <h4 slot="header" class="card-title">Esqueceu a senha?</h4>
                <form>
                  <h5>
                    Informe seu e-mail que enviaremos instruções para você criar sua nova senha.
                  </h5>
                  <input  type="email" placeholder="Email" v-model="novo.email" required="required" autofocus="autofocus" class="form-control" style="margin-bottom:15px;">
                  <!--Recaptcha-->
                  <g-recaptcha :sitekey='sitekey' :callback="callback" style="margin-bottom: 10px;" ></g-recaptcha> 

                  <div class="text-center" style="margin-top:20px;">
                        <button type="submit" class="btn btn-primary btn-fill float-left " @click.prevent="novaSenha">  
                          Enviar
                        </button>
                        <button type="submit" class="btn btn-light btn-fill float-left " @click.prevent="cancelar" style="margin-left:5px;">  
                          Cancelar
                        </button>
                  </div>    
                </form> 
            </div>
            <div class="col-md-6">
              <img src="/img/ilust-senha.jpg" style='width: 100%;'>
            </div>
          </div> 
        </div>    
      </div>
    </div> 
  </section>   
</template>
<script>
  import Card from 'src/components/Cards/Card.vue'
  import axios from 'axios';
  import store from "src/store.js"
  import 'src/controller/site/manifestacaoController.js'
  import 'src/controller/site/homeController.js'
  import gRecaptcha from 'src/components/recaptcha.vue'
  import Reload from "src/components/Reload-v1.vue";

  export default {
    components: {
      Card,
      gRecaptcha,
      Reload,
    }, 
    data () {
      return {
        email:null,
        senha:null,
        resposta:null,
        sitekey: '6LctowIaAAAAAEIUAiug_2YU7EGwnaE1a82a_W_t',
        token: null,
        novo:{
          email:null,
        },
        reload_hab: false,
      }
    },
    methods: {
      callback(token){
        this.token = token;
      },
      async novaSenha(){
        try {
          if (this.novo.email == null || this.novo.email == "") {
            return false;
          }
          let email =this.novo.email;
          this.novo.email = null;
          grecaptcha.reset();
          this.reload_hab = true;
          let data = await this.$trocarSenhaLogin(email,this.token);
          this.reload_hab = false;
          this.$alert("Um E-mail foi enviado para realizar a troca de senha.");
          this.$router.push({name: 'loginCidadao'} );
         // grecaptcha.reset();
          //console.log(this.novo.email);
        } catch (e) {
          throw e;
        }
      },
      cancelar(){
        this.$router.push({name: 'loginCidadao'} );
      },

     
    },
    beforeMount(){
      
    }
    
  }

</script>
<style>
    ol {
        list-style: none;
    }
    .bread{
      padding-right: 0px;
      padding-left: 0px;
    }
    .bread-crumb {
        width: 100%;
        float: left;
        margin: 0px 0px 20px 0;
        position: relative;
        display: block;
        margin-top: 8px;
        font-size: 12px;
        font-weight: 700;
        text-transform: uppercase;
    }
    .breadcrumb-fill0 {
        padding: 10px;
        background: #ffffff;
        border-radius: 5px;
        box-shadow: 0 0 40px -10px rgba(0, 0, 0, 0.25);
    }
    .bread-crumb li {
        height: auto;
        line-height: 30px;
        float: left;
        padding: 0 12px;
    }
    .bread-text,.bread-text:hover{
      color:black;
    }
</style>
